export const INBOX_ASSIGNED_REQUESTS_LOAD = 'INBOX_ASSIGNED_REQUESTS_LOAD'
export const INBOX_ASSIGNED_REQUESTS_LOAD_PENDING = 'INBOX_ASSIGNED_REQUESTS_LOAD_PENDING'
export const INBOX_ASSIGNED_REQUESTS_LOAD_FULFILLED = 'INBOX_ASSIGNED_REQUESTS_LOAD_FULFILLED'
export const INBOX_ASSIGNED_REQUESTS_LOAD_REJECTED = 'INBOX_ASSIGNED_REQUESTS_LOAD_REJECTED'

export const INBOX_REQUEST_STATISTICS_LOAD = 'INBOX_REQUEST_STATISTICS_LOAD'
export const INBOX_REQUEST_STATISTICS_LOAD_PENDING = 'INBOX_REQUEST_STATISTICS_LOAD_PENDING'
export const INBOX_REQUEST_STATISTICS_LOAD_FULFILLED = 'INBOX_REQUEST_STATISTICS_LOAD_FULFILLED'
export const INBOX_REQUEST_STATISTICS_LOAD_REJECTED = 'INBOX_REQUEST_STATISTICS_LOAD_REJECTED'
